import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContainerState } from './types';

export const initialState: ContainerState = {
  dealerSegmentSettings: { data: null, loading: false, error: null },
};

const dealerSegmentSettingsSlice = createSlice({
  name: 'dealerSegmentSettingsComponentState',
  initialState,
  reducers: {
    requestDealerSegmentSettings(state, action: PayloadAction<any>) {
      state.dealerSegmentSettings.loading = true;
      state.dealerSegmentSettings.error = null;
    },
    requestDealerSegmentSettingsSuccess(state, action: PayloadAction<any>) {
      state.dealerSegmentSettings.data = action.payload;
      state.dealerSegmentSettings.loading = false;
    },
    requestDealerSegmentSettingsError(state, action: PayloadAction<any>) {
      state.dealerSegmentSettings.error = action.payload;
      state.dealerSegmentSettings.loading = false;
    },
    requestUpdateDealerSegmentSettings(state, action: PayloadAction<any>) {
      state.dealerSegmentSettings.loading = true;
      state.dealerSegmentSettings.error = null;
    },
    requestUpdateDealerSegmentSettingsSuccess(state) {
      state.dealerSegmentSettings.loading = false;
    },
    requestUpdateDealerSegmentSettingsError(state, action: PayloadAction<any>) {
      state.dealerSegmentSettings.error = action.payload;
      state.dealerSegmentSettings.loading = false;
    },
    requestCreateDealerSegmentSettings(state, action: PayloadAction<any>) {
      state.dealerSegmentSettings.loading = true;
      state.dealerSegmentSettings.error = null;
    },
    requestCreateDealerSegmentSettingsSuccess(state) {
      state.dealerSegmentSettings.loading = false;
    },
    requestCreateDealerSegmentSettingsError(state, action: PayloadAction<any>) {
      state.dealerSegmentSettings.error = action.payload;
      state.dealerSegmentSettings.loading = false;
    },
  },
});

export const {
  actions: dealerSegmentSettingsActions,
  reducer,
  name: sliceKey,
} = dealerSegmentSettingsSlice;
